/*eslint @typescript-eslint/no-explicit-any: ["off"]*/

import type { Nullable } from "vite-node"
import { isPlainObjDeeplyEqual } from "./isPlainObjDeeplyEqual"

/**
 * @param input
 *
 * @returns true/false if each object in the list is deeply equal and in the same order
 */
export function isPlainObjListDeeplyEqual<T extends object>(
  list1: Nullable<Array<T>>,
  list2: Nullable<Array<T>>
): boolean {
  if (list1 === list2) return true

  if (list1?.length !== list2?.length) return false

  for (let index = 0; index < list1!.length; index++) {
    const e1 = list1![index]
    const e2 = list2![index]
    if (!isPlainObjDeeplyEqual(e1, e2)) return false
  }

  return true
}

